'use client';
import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Styles
import MarketAndForeignTradeTemplateStyle from './style';

//* Components
import NewHeroSection from '../../BusinessRegistration/components/NewHeroSection';
const PublicationsGlobalSection = dynamic(() => import('@/sections/PublicationsGlobalSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ProductSection = dynamic(() => import('../../MacroeconomicIndicators/components/ProductSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FdiLegislationSection = dynamic(() => import('../../InvestmentLegislation/components/FdiLegislationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const NecessaryInformationSection = dynamic(() => import('../../BusinessRegistration/components/NecessaryInformationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const MajorExportSection = dynamic(() => import('../components/MajorExportSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ChartSection = dynamic(() => import('@/sections/ChartSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const RangeColumnChart = dynamic(() => import('@/sections/ChartSection/components/RangeColumnChart'), {
	ssr: false,
});
const LineChart = dynamic(() => import('@/sections/ChartSection/components/LineChart'), {
	ssr: false,
});
const MemberCountriesSection = dynamic(() => import('../components/MemberCountriesSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const MarketAndForeignTradeTemplate = ({ pageData }) => {
	const { content, faqs, publications } = pageData;
	const { hero, consumer_market, membership, member_countries, trade_regime, info, major_export, import_export, main_export } = content;

	const formattedData = main_export.values?.map(({ title, additional_info }, index) => {
		const { color, value, top_color } = additional_info;

		const isNegative = value < 0;

		return {
			date: title,
			value: isNegative ? 0 : value,
			openValue: isNegative ? value : 0,
			value2: isNegative ? value - 1.5 : value + 1.5,
			openValue2: isNegative ? value - 1.5 - 12 : value + 1.5 + 12,
			isNegative,
			id: index,
			color,
			color2: top_color || '#E47F12',
		};
	});

	return (
		<MarketAndForeignTradeTemplateStyle>
			<NewHeroSection {...hero} />

			<ProductSection {...consumer_market} />

			<FdiLegislationSection {...membership} />

			<MemberCountriesSection {...member_countries} />

			<NecessaryInformationSection
				title={trade_regime.trade_regime_title}
				items={trade_regime.items}
			/>

			<ProductSection {...info} />

			<ChartSection
				{...import_export}
				Chart={LineChart}
				items={import_export.values}
				isLegendSection
				isBlackBackgroundVersion
				className='import-export-chart'
			/>

			<ChartSection
				{...main_export}
				hideXAxisLabel
				Chart={RangeColumnChart}
				items={formattedData}
				isBlackBackgroundVersion
				isLegendSection
			/>

			<MajorExportSection {...major_export} />

			<Container>
				<PublicationsGlobalSection
					publications={publications}
					isPublicationGridVersion
					publicationsTitle='publications'
				/>
			</Container>

			<FAQSection items={faqs} />
		</MarketAndForeignTradeTemplateStyle>
	);
};

export default MarketAndForeignTradeTemplate;
